// extracted by mini-css-extract-plugin
export default {"container":"home_container__LkI7l","header":"home_header__CdMNq","banner":"home_banner__Z517K","top-wining":"home_top-wining__Ft+zG","games":"home_games__5ahh+"};